import { FC } from 'react'

export const SlidePlaceholder: FC = ({ children }) => (
  <div className="flex w-full h-[21.875rem] text-center justify-center items-center">
    {children}
  </div>
)
